{
  "iconsList1": {
    "icon": {
      "url": "/icons/icon_point.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "dot",
    "layout": "row",
    "items": [
      {
        "title": "Goal Assistant"
      },
      {
        "title": "Supporting programmes"
      },
      {
        "title": "A dedicated consultant"
      }
    ]
  },
  "iconsList10": {
    "icon": {
      "url": "/icons/icon_point_blue.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "dot",
    "layout": "column",
    "items": [
      {
        "title": "Quick entry to facilities without ID"
      },
      {
        "title": "Access to foreign facilities"
      },
      {
        "title": "Search for facilities in seconds"
      },
      {
        "title": "Easy card management for children and loved ones"
      },
      {
        "title": "Information about new products and competitions"
      }
    ]
  },
  "iconsList11": [
    {
      "text": "You will have an impact on building healthy habits in the organisation by giving access to state-of-the art tools and services",
      "icon": {
        "url": "/icons/icon-19.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "You will lower absenteeism in your team thanks to comprehensive preventive health care",
      "icon": {
        "url": "/icons/icon-20.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "You will strengthen your employees in their care for mental- and physical well-being",
      "icon": {
        "url": "/icons/icon-21.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "You will enable constant development of your team by using modern technologies that help people achieve their goals",
      "icon": {
        "url": "/icons/icon-22.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    }
  ],
  "iconsList12": [
    {
      "text": "Identifying needs",
      "subtext": "A smart choice of programme that meets individual needs"
    },
    {
      "text": "Personalised content",
      "subtext": "A selection of goal-oriented services, consultations, webinars and courses"
    },
    {
      "text": "Expert support",
      "subtext": "Full assistance and tips from a programme consultant, individual consultations with specialists"
    },
    {
      "text": "Keeping track of the results",
      "subtext": "Development based on modern methods of learning and user engagement"
    }
  ],
  "iconsList13": [
    {
      "text": "Measurement",
      "subtext": "Measure the well-being level in your company"
    },
    {
      "text": "Strategy",
      "subtext": "Together with us, build a data-driven strategy adapted to your organisation"
    },
    {
      "text": "Action",
      "subtext": "Deliver adequate products and solutions that support employees end-to-end"
    },
    {
      "text": "Results",
      "subtext": "Watch how well-tried benefits and tools improve the employees’ health and satisfaction"
    }
  ],
  "iconsList2": {
    "icon": {
      "url": "/icons/icon_point_blue.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "dot",
    "layout": "row",
    "items": [
      {
        "title": "Cafeteria solution"
      },
      {
        "title": "Gamification and motivation"
      },
      {
        "title": "Intranet 2.0"
      },
      {
        "title": "eSignature"
      }
    ]
  },
  "iconsList3": [
    {
      "text": "Measure the well-being level in your company and get to know key areas that require support",
      "icon": {
        "url": "/icons/icon_search.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Take advantage of comprehensive support from experts and advisors, and choose the right tools",
      "icon": {
        "url": "/icons/icon_person.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Watch how a tailored well-being strategy helps you build a strong and resilient team",
      "icon": {
        "url": "/icons/icon_hands.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    }
  ],
  "iconsList4": {
    "icon": {
      "url": "/icons/icon_checkmark.svg",
      "alternative": "",
      "width": "40",
      "height": "40"
    },
    "type": "checkmark",
    "layout": "row",
    "items": [
      {
        "title": "You will evaluate the level of your company’s well-being"
      },
      {
        "title": "You will listen to your employees and their needs"
      },
      {
        "title": "You will create a customised well-being strategy"
      },
      {
        "title": "You will support your team with selected tools, services and programmes"
      }
    ]
  },
  "iconsList5": [
    {
      "text": "Examine your company’s needs",
      "icon": {
        "url": "/icons/icon-4.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Build a well-being strategy adapted to the organisation’s needs",
      "icon": {
        "url": "/icons/icon-5.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Choose effective tools and programmes",
      "icon": {
        "url": "/icons/icon-6.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    },
    {
      "text": "Measure and verify the results",
      "icon": {
        "url": "/icons/icon-7.svg",
        "alternative": "",
        "width": "72",
        "height": "72"
      }
    }
  ],
  "iconsList6": [
    {
      "title": "eTravelpass",
      "icon": {
        "url": "/icons/earth-2.svg",
        "link": "https://benefitsystems.pl/en/for-you/etravelpass/"
      }
    },
    {
      "title": "MultiBilet",
      "icon": {
        "url": "/icons/ticket-1.svg",
        "link": "https://benefitsystems.pl/en/for-you/multibilet/"
      }
    }
  ],
  "iconsList7": {
    "icon": {
      "url": "/icons/icon_checkmark_blue.svg",
      "alternative": "",
      "width": "32",
      "height": "32"
    },
    "type": "checkmark-blue",
    "layout": "row",
    "items": [
      {
        "title": "Cutting-edge automation that allows you to save time"
      },
      {
        "title": "Intuitive tools that do not require advanced technology knowledge"
      },
      {
        "title": "A flexible module offer tailored to the company’s needs"
      },
      {
        "title": "Intuitive reporting and full monitoring for the HR"
      },
      {
        "title": "A wide range of benefits and a flexible funding model, including from the Social Fund"
      },
      {
        "title": "Full user support with hotline available 7 days a week"
      }
    ]
  },
  "list1": [
    {
      "title": "ACCESSIBILITY",
      "text": "Admission to over <span>15,000 facilities</span> in total, in Poland and abroad"
    },
    {
      "title": "DIVERSITY",
      "text": "<span>55 various activities</span>, including seasonal ones, such as standup paddleboarding (SUP), kayaks or ice-skating"
    },
    {
      "title": "KNOWLEDGE AND MOTIVATION",
      "text": "Online training, videos for beginners, educational, motivational, and inspirational content created by experts"
    }
  ],
  "logos": [
    {
      "url": "/icons/company_1.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_2.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_3.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_4.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_5.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    }
  ],
  "logos2": [
    {
      "url": "/icons/company_berlitz.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_8.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_lerni.png",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_10.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    }
  ],
  "logos3": [
    {
      "url": "/icons/company_15.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_12.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_13.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_14.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    },
    {
      "url": "/icons/company_11.svg",
      "alternative": "",
      "width": "72",
      "height": "72"
    }
  ]
}